module.exports = __webpack_public_path__ + "img/23.9301642.webp";